<!--setting=  empresa-->

<div class="body grid-autofill col-xxs-12 grid lg:grid-cols-1 md:grid-cols-1">
    <msc-common-nav [data]="navData"></msc-common-nav>
</div>
<section>
    <router-outlet></router-outlet>
</section>
